import React, { useState, useEffect } from "react";
import { AlarmData} from "../Common/Types/types";
import AlarmStatisticsGrid from "./AlarmStatisticsGrid";
import { useSelector } from "react-redux";
import { getParamsSelector, updateParams } from "../Common/Slices/ParamSlice";
import { fetchAlarmDatas, getAlarmsLoadingSelector, getAlarmsSelector } from "./Slice";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useAppDispatch } from "../Core/store.hooks";
import FormatAlarms from "./FormatAlarms";

interface AlarmStatisticsGridWidgetProps {
    id: string;
    header: string;
}

const AlarmStatisticsGridWidget = (props: AlarmStatisticsGridWidgetProps) => {
    const [AlarmDatas, updateAlarmDatas] = useState<AlarmData[]>();
    const [dataProcessed, setDataProcessed] = useState<boolean>(false);

    const alarms = useSelector(getAlarmsSelector);
    const params = useSelector(getParamsSelector);
    const loadingState = useSelector(getAlarmsLoadingSelector);
    const dispatch = useAppDispatch();

    useEffect(()=>{
        if(loadingState !== "pending"){
            updateAlarmDatas(FormatAlarms.durationInHours(alarms))
            setDataProcessed(true);
        }
    },[alarms])

    useEffect(()=>{
        if (loadingState==="pending"){
            setDataProcessed(false)
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
    },[loadingState])

    const handleRowClick = (id:string) =>{
        if (id != null){
            let newParams = {...params}
            newParams.alarmText = id
            dispatch(updateParams(newParams))
        }
    }
    
    if (!dataProcessed) return <Spinner text="data" />;
    if (AlarmDatas == null || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if (AlarmDatas != null && AlarmDatas.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    return <AlarmStatisticsGrid clickHandler={handleRowClick} alarmData={AlarmDatas}/>;
};
export default AlarmStatisticsGridWidget;
